import { useNavigate } from 'react-router';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useCallback, useState } from 'react';
import { QUESTION_FIELDS } from '~/modules/identification/forms/GettingStarted/constants.tsx';
import { Grid } from '@mui/material';
import { errorMessages } from '~/constants/errorMessages.ts';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import TitlePencilField from '~/components/TitlePencilField/TitlePencilFIeld.tsx';
import { QuestionnaireModal } from '~/modules/identification/forms/GettingStarted/components/QuestionnaireModal.tsx';
import { selectCompletedForms } from '~/store/identification-form/selectors';
import { useAppDispatch } from '~/store/appDispatch';
import { setIdentificationError } from '~/store/identification-form/slices';

export const CreationClientInfoReIdentification = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isGettingStartedCompleted } = useSelector(selectCompletedForms) || {};

  const {
    formState: { errors },
  } = useFormContext();

  const hasError = Object.keys(errors).some((item) => QUESTION_FIELDS.includes(item));
  const [isModalOpened, setIsModalOpened] = useState(false);

  const handleClose = useCallback(
    (shouldExit?: boolean) => {
      if (shouldExit) {
        dispatch(
          setIdentificationError({
            errorMessage: errorMessages.VISIT_BRANCH_REQUIRED,
            discard: () => navigate('/services'),
          })
        );
      }
      setIsModalOpened(false);
    },
    [dispatch]
  );

  const handleOpen = useCallback(() => {
    setIsModalOpened(true);
  }, []);

  return (
    <>
      <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ width: '100%' }}>
        <Grid size={{ md: 6, sm: 12, xs: 12 }}>
          <FormInput name="contragentType.label" disabled label="Тип клієнта" fullWidth />
        </Grid>
        {!isGettingStartedCompleted && (
          <Grid size={12}>
            <TitlePencilField
              title="Надайте уточнюючу інформацію"
              dataName="explanation"
              onClick={handleOpen}
              errorMessage={hasError ? errorMessages.FILL_CLARIFYING_INFORMATION : ''}
            />
          </Grid>
        )}
      </Grid>
      <QuestionnaireModal isOpened={isModalOpened} onContinue={handleClose} />
    </>
  );
};
